module.exports = __webpack_public_path__ + "static/media/plunger.778177ed.mp3";